import { gql } from "@apollo/client";

export const getSchedulePremiumByScheduleId = gql`
query($scheduleId: String!){
  getSchedulePremiumByScheduleId(scheduleId: $scheduleId) {
    message
    response
  }
}`;